import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControl, FormHelperText } from '@mui/material';

import {
    useSeparateLabelInputWrapperFormControlStyles,
    useFormHelperText,
} from './SeparateLabelInputWrapperStyles';

interface SeparateLabelInputWrapperProps {
    id: string;
    children: ReactElement;
    required?: boolean;
    label?: string;
    color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    helperText?: string;
    languageNamespaces?: string[];
    error?: boolean;
    disabled?: boolean;
    placement?: 'top' | 'bottom' | 'right' | 'left';
}

export const SeparateLabelInputWrapper = ({
    id,
    children,
    color,
    label,
    required,
    helperText,
    languageNamespaces,
    error,
    disabled,
    placement,
}: SeparateLabelInputWrapperProps): ReactElement => {
    const helperTextClasses = useFormHelperText();
    const formControlClasses = useSeparateLabelInputWrapperFormControlStyles({
        placement,
        required,
    });

    const { t } = useTranslation(languageNamespaces);

    return (
        <FormControl disabled={disabled} color={color} classes={formControlClasses}>
            <label htmlFor={id}>{t(label)}</label>
            <div className={formControlClasses.contentWrapper}>
                {children}
                <FormHelperText error={error} classes={helperTextClasses}>
                    {t(helperText)}
                </FormHelperText>
            </div>
        </FormControl>
    );
};

SeparateLabelInputWrapper.defaultProps = {
    color: 'secondary',
    variant: 'outlined',
    required: false,
    error: false,
    disabled: false,
    placement: 'left',
};
